<script setup lang="ts">
import RCouponApplyModal from './RCouponApplyModal.vue'

const { t } = useI18n()
const { event } = useEvent()
const discountStore = useDiscountStore()
const couponModal = ref<InstanceType<typeof RCouponApplyModal> | null>(null)
</script>

<template>
  <button
    class="cart-button relative flex h-10 w-10 items-center justify-center rounded-full transition-colors"
    @click="[couponModal?.open(), event('product_catalog_open_coupon_modal_click')]"
  >
    <RIcon size="24" name="material-symbols:percent-discount-outline-rounded" />
    <span class="sr-only">{{ t('components.couponApplyModal.title') }}</span>
    <div
      v-if="discountStore.coupon?.code"
      class="counter absolute bottom-0 right-0 flex h-4 w-4 items-center justify-center rounded-full border-1 border-apple bg-apple text-xs font-semibold text-white transition-colors sm:h-[17px] sm:w-[17px] sm:text-[12px]"
    >
      1
    </div>
  </button>

  <RCouponApplyModal ref="couponModal" />
</template>
